import React from "react";
import { useLocation } from "react-router-dom"; // Import useLocation
import "./PageDetail.scss";

import PageBand from "./PageBand";
import MyBreadcrumbs from "../../components/form/MyBreadcrumbs";
import { GLOBALSETTINGS, LOCALSTORAGENAME, RouteKeywords } from "../../data/constants";
import { useUser } from "../../context/UserContext";
import { LABELNAMES, GLOBALMESSAGES } from "../../constants/messages";
import { useMenu } from "../../context/MenuContext";
import { getFilteredMenu } from "../../utils/commonHelper";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

const PageDetail = () => {
  const location = useLocation();
  const { firstName, lastName, userName } = useUser();
  const { menu } = useMenu();
  const { isImpersonating } = useSelector((state: RootState) => state.impersonation);
  const isDetailPage = location.pathname === GLOBALSETTINGS.LIST_DETAIL_PAGE;
  const isHomePage = location.pathname === GLOBALSETTINGS.DEFAULT_PAGE;
  const isFirstTimeLogin = localStorage.getItem(LOCALSTORAGENAME.ISFIRSTTIMELOGIN) === "true";
  const filteredMenu = getFilteredMenu(menu);
  const matchedSection = filteredMenu.find((section) =>
    section.listItems.some((item) => item.url.toLowerCase() === location.pathname.toLowerCase())
  );

  const sanitize = (value?: string | null) =>
    value && value.trim().toLowerCase() !== "null" ? value.trim() : "";

  const firstNameText = sanitize(firstName);
  const lastNameText = sanitize(lastName);
  // While impersonating, firstName/lastName in context still belong to the admin
  // (setOrRevokeImpersonation only swaps userId/userName), so use the impersonated
  // session's userName instead to avoid showing the original user's name here.
  const fullName = isImpersonating
    ? sanitize(userName)
    : [firstNameText, lastNameText].filter(Boolean).join(" ");

  // Messages and View Account (user-profile) aren't part of the File Explorer sidenav menu, so
  // matchedSection never resolves for them and they'd otherwise fall through to the File
  // Explorer default below (Bug 80053).
  const pathLower = location.pathname.toLowerCase();
  const isMessagesPage = RouteKeywords.Messages.some((keyword) => pathLower.includes(keyword));
  const isUserProfilePage = RouteKeywords.UserProfile.some((keyword) =>
    pathLower.includes(keyword),
  );

  const sectionTitle = isMessagesPage
    ? LABELNAMES.COMMUNICATION
    : isUserProfilePage
      ? LABELNAMES.PROFILE
      : matchedSection
        ? matchedSection.title === ""
          ? LABELNAMES.FILE_EXPLORER
          : matchedSection.title
        : LABELNAMES.FILE_EXPLORER;

  return (
    <PageBand
      title={sectionTitle}
      impersonating={isImpersonating}
      homeActive={!isDetailPage}
      subtitle={
        (isFirstTimeLogin || isHomePage) && (
          <h6>
            Hello{fullName ? `, ${fullName}!` : "!"}{" "}
            {isFirstTimeLogin ? GLOBALMESSAGES.WELCOME : GLOBALMESSAGES.WELCOME_BACK}
          </h6>
        )
      }
      // Only the folder trail: MyBreadcrumbs renders the File Explorer's Redux breadcrumb slice,
      // which is meaningless on any other route.
      breadcrumbs={isDetailPage && <MyBreadcrumbs />}
    />
  );
};

export default PageDetail;
